import React from 'react';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { createUseStyles } from 'react-jss';
import Lottie from 'react-lottie-player';
import { useTranslation } from 'react-i18next';
import { PrivacyNotice } from '../privacy-notice';
import authIconData from './auth-icon.json';
import { layoutDefaults } from '../../utils/layout-defaults';

function OAuthModalTitle({ analytics, getPrivacyPolicyFromRemote }) {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Lottie
        play
        loop={false}
        animationData={authIconData}
        className={classes.icon}
      />
      <FadeIn>
        <div className={classes.title}>{t('oauth.who-are-you')}</div>
      </FadeIn>

      <FadeIn delay={1600}>
        <PrivacyNotice
          analytics={analytics}
          getPrivacyPolicyFromRemote={getPrivacyPolicyFromRemote}
        />
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginTop: layoutDefaults.smallVerticalMargin,
    // border: '1px solid red',
  },
  icon: {
    height: 120,
  },
});

export { OAuthModalTitle };
